export const UpdateInvestmentTermText = (investmentTerm) => {
  let months = investmentTerm.split('Y')[1] || investmentTerm
  if (months === '0MO' || !months.includes('MO')) return `${investmentTerm.split('Y')[0]}Y`
  return investmentTerm
}